<template>
  <div class="w-full bg-[#F7F7F7] p-12 flex flex-col items-center">
    <h2 class="text-4xl font-semibold text-[#3C3C3C] text-center">Contact Information</h2>
    <div class="w-16 h-[2px] bg-[#E9A53D] mx-auto mt-3 mb-8"></div>

    <div class="bg-white shadow-lg rounded-lg w-full max-w-3xl p-6">
      <div class="flex justify-center gap-4 mb-6">
        <button
            v-for="(tab, index) in locations"
            :key="index"
            @click="activeTab = index"
            class="px-6 py-2 text-lg font-medium border-b-2"
            :class="activeTab === index ? 'border-[#E9A53D] text-[#3C3C3C]' : 'border-transparent text-gray-500'"
        >
          {{ tab.name }}
        </button>
      </div>

      <transition name="fade" mode="out-in">
        <div v-if="locations[activeTab]" class="text-center">
          <h3 class="text-2xl font-bold text-[#3C3C3C] mb-4">{{ locations[activeTab].name }}</h3>
          <p class="text-[#3C3C3C] mb-2"><strong>Address:</strong> {{ locations[activeTab].address }}</p>
          <p v-if="locations[activeTab].local" class="text-[#3C3C3C] mb-2"><strong>Unit:</strong> {{ locations[activeTab].local }}</p>
          <p class="text-[#3C3C3C] mb-2"><strong>Phone:</strong> <a :href="'tel:' + locations[activeTab].phone" class="hover:underline">{{ locations[activeTab].phone }}</a></p>
          <p class="text-[#3C3C3C] mb-2"><strong>Email:</strong> <a :href="'mailto:' + locations[activeTab].email" class="hover:underline">{{ locations[activeTab].email }}</a></p>
          <div v-if="locations[activeTab].image" class="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4 items-center">
            <iframe
                class="w-full h-60 rounded-lg shadow-md"
                :src="locations[activeTab].mapUrl"
                allowfullscreen
                loading="lazy"
            ></iframe>
            <img
                :src="locations[activeTab].image"
                :alt="`Location photo: ${locations[activeTab].name}`"
                class="w-full h-60 object-cover rounded-lg shadow-md"
            />
          </div>
          <div v-else class="mt-4">
            <iframe
                class="w-full h-60 rounded-lg shadow-md"
                :src="locations[activeTab].mapUrl"
                allowfullscreen
                loading="lazy"
            ></iframe>
          </div>
        </div>
      </transition>
    </div>

    <div class="w-full max-w-4xl mt-12">
      <h3 class="text-2xl font-bold text-[#3C3C3C] text-center mb-6">Department Contact Numbers</h3>
      <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div
            v-for="(item, index) in contacts"
            :key="index"
            class="bg-white shadow-md rounded-lg p-6 flex flex-col items-center text-center"
        >
          <h4 class="text-xl font-semibold text-[#3C3C3C] mb-2">{{ item.department }}</h4>
          <span class="w-6 h-[2px] bg-[#E9A53D] mb-4"></span>
          <div v-if="item.phone" class="flex items-center gap-2 text-[#3C3C3C]">
            <span class="text-[#E67E22]">📞</span> <a :href="'tel:' + item.phone" class="hover:underline">{{ item.phone }}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeTab: 0,
      locations: [
        {
          name: "Poznań",
          address: "Roosevelta 6/7, Poznań 60-880",
          local: "Unit 6, Floor 2",
          phone: "509-661-777",
          email: "biuro@projectspot.pl",
          mapUrl: "https://www.google.com/maps/embed/v1/place?key=AIzaSyChnsnamrdKYe4vx1HzdqQwGQ5pI0C4I_M&q=52.41176692181754,16.913620228858075&zoom=15",
          image: "/images/components/image5.jpeg"
        },
        {
          name: "Wrocław",
          address: "Litomska 9/1, Wrocław 53-641",
          phone: "899-088-922",
          email: "olga.wasilkiewicz@projectspot.pl",
          mapUrl: "https://www.google.com/maps/embed/v1/place?key=AIzaSyChnsnamrdKYe4vx1HzdqQwGQ5pI0C4I_M&q=51.11506447168328,17.009465961104887&zoom=15"
        }
      ],
      contacts: [
        { department: "Office", phone: "509-661-777" },
        { department: "Coordination & Execution", phone: "509-661-888" },
        { department: "Technical Department", phone: "509-661-999" }
      ]
    };
  }
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
